import React from 'react';

function Contact() {
  return (
    <div>
      {/* Hero Section */}
      <div className="container-fluid pt-5 bg-primary hero-header">
        <div className="container pt-5">
          <div className="row g-5 pt-5 align-items-center">
            <div className="col-lg-6 text-center text-lg-start mb-lg-5">
              <h1 className="display-4 text-white mb-4 animated slideInRight">Contact Us</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center justify-content-lg-start mb-0">
                  <li className="breadcrumb-item"><a className="text-white" href="/">Home</a></li>
                  <li className="breadcrumb-item text-white active" aria-current="page">Contact</li>
                </ol>
              </nav>
              <p className="text-white-50 mt-3">
                Have a question or want to discuss a project? Reach out to us via phone, email, or the contact form below. We're here to help!
              </p>
            </div>
            <div className="col-lg-6 text-center text-lg-end">
              <img className="img-fluid" src="assets/img/hero-img.png" alt="Contact Hero" style={{ maxHeight: 300 }} />
            </div>
          </div>
        </div>
      </div>

      {/* Contact Info Section */}
      <div className="container py-5">
        <div className="text-center mb-5">
          <div className="btn btn-sm border rounded-pill text-primary px-3 mb-3">Contact Info</div>
          <h1 className="mb-4">Get in Touch</h1>
          <p className="text-muted mb-4">
            We are available to discuss your requirements and help your business grow with our solutions. Contact us through phone, email, or the form below.
          </p>
          <p className="mb-1">📞 Call us: <strong>+91 8459432930</strong></p>
          <p>✉️ Email: <strong>blueviperstechnology@gmail.com</strong></p>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-7">
            <h3 className="text-center mb-4">Send Us a Message</h3>
            <form>
              <div className="row g-3">
                <div className="col-md-6">
                  <input type="text" className="form-control" placeholder="Your Name" />
                </div>
                <div className="col-md-6">
                  <input type="email" className="form-control" placeholder="Your Email" />
                </div>
                <div className="col-12">
                  <input type="text" className="form-control" placeholder="Subject" />
                </div>
                <div className="col-12">
                  <textarea className="form-control" placeholder="Message" style={{ height: 150 }} />
                </div>
                <div className="col-12 text-center">
                  <button type="submit" className="btn btn-primary px-5 py-2">Send Message</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      <div className="container-fluid bg-primary py-5">
        <div className="container text-center text-white">
          <h2 className="mb-3">Ready to Connect?</h2>
          <p className="mb-1">Call us now at <strong>+91 8459432930</strong></p>
          <p className="mb-4">Or email us at <strong>blueviperstechnology@gmail.com</strong></p>
          <a href="tel:+918459432930" className="btn btn-light rounded-pill px-4 py-2">Call Now</a>
        </div>
      </div>
    </div>
  );
}

export default Contact;
